import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStore from "../../Store/Store";
import SimulationTutorial from "../TutorialComponents/SimulationTutorial";
import { createPortal } from "react-dom";

/**
 * Overlay component that covers the iframe during simulation cell insertion
 * Shows a blurred backdrop with "Please wait" message to prevent user interaction
 */
const CellInsertionOverlay: React.FC = () => {
  const theme = useTheme();

  const { isInsertingSimulationCells } = useStore((state) => ({
    isInsertingSimulationCells: state.isInsertingSimulationCells,
  }));

  // Don't show if not inserting cells
  if (!isInsertingSimulationCells) {
    return null;
  }

  const overlay = (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bgcolor="rgba(255, 255, 255, 0.05)" // Almost transparent
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      zIndex={10000100} // Consistent with other tutorial overlays
      sx={{
        backdropFilter: "blur(5px)", // Subtle blur
        pointerEvents: "all", // Prevent interaction with iframe
      }}
    >
      <Box
        width="80%"
        maxWidth={400}
        textAlign="center"
        sx={{
          bgcolor: "rgba(255, 255, 255, 0.9)",
          borderRadius: 3,
          p: 3,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h6"
          mb={2}
          sx={{
            fontWeight: 500,
            color: theme.custom.darkerGrey,
          }}
        >
          Inserting Simulation Steps
        </Typography>

        <Typography
          variant="body2"
          sx={{
            opacity: 0.8,
            fontWeight: "normal",
            color: theme.custom.darkerGrey,
            lineHeight: 1.5,
          }}
        >
          Please wait while simulation cells are being placed on the diagram...
        </Typography>
      </Box>
      <SimulationTutorial
        isPopup={false}
        onClose={() => {}}
        isOverlayMode={true}
      />
    </Box>
  );

  return createPortal(overlay, document.body);
};

export default CellInsertionOverlay;
